import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {BlockUI} from "primereact/blockui";

import FormLocker from "../../util/FormLocker";

const ZipcodeFormComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);
  const [types, setTypes] = useState([]);
  const [fields, setFields] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [levels, setLevels] = useState([]);
  const [positions, setPositions] = useState([]);
  const [messageHu, setMessageHu] = useState('');
  const [messageEn, setMessageEn] = useState('');


  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/hungarian-zip-code/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          window.App.forceUpdate()
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderZipcodeList: Math.random(),
            selectedZipcodeId: response.data.data.id
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarZipcodeForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/hungarian-zip-code",
        data,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          window.App.forceUpdate()
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderZipcodeList: Math.random(),
            selectedZipcodeId: response.data.data.id
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarZipcodeForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };
  

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (formData && formData.message) {
      setMessageEn(formData.message)
    }
  }, [formData.message])

  useEffect(() => {
    if (window.App.state.propsZipcode && window.App.state.propsZipcode.id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/hungarian-zip-code/" + window.App.state.propsZipcode.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('zipcode_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
                    <span>
                      <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                    </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            window.App.setState({
                              sidebarZipcodeForm: false,
                            })
                          }}
                          className="p-button-secondary p-ml-2">
                  </Button>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="zip_code" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="zip_code"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('zip_code')}</label>
                      <span className="p-d-block">
                        <InputText id="zip_code" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       zip_code: e.target.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       zip_code: e.target.value
                                     })
                                   }}
                                   value={formData.zip_code}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-8"}>
                  <Field name="city" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="city"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('city')}</label>
                      <span className="p-d-block">
                        <InputText id="city" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       city: e.target.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       city: e.target.value
                                     })
                                   }}
                                   value={formData.city}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(ZipcodeFormComponent);
